import { CreateCustomEmailNotificationDto, InstructionValidationStatuses } from "app/ApiClient";

export class InstructionValidationException extends Error {
  constructor(public dto: Validated, public message: string) {
    super(message);
  }

  protected isInstructionValidationException = true;

  static isInstructionValidationException(obj: unknown): obj is InstructionValidationException {
    return obj instanceof Object && obj.hasOwnProperty("isInstructionValidationException");
  }
}

interface Validated {
  createCustomEmailNotificationDto?: CreateCustomEmailNotificationDto | undefined;
  validationStatus?: InstructionValidationStatuses;
}

export function checkAndThrowInstructionValidationException(dto: Validated, message = "Validation Error") {
  if (dto.validationStatus === InstructionValidationStatuses.Failed) {
    throw new InstructionValidationException(dto, message);
  }
}
